import { pushErrorRef, queryClient } from '@/api/queryClient';
import { useToastContext } from '@payaca/ambrosia';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';

export const QueryClientWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pushError } = useToastContext();

  useEffect(() => {
    pushErrorRef.current = pushError;
  }, [pushError]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
    </QueryClientProvider>
  );
};
